<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-align: center;">Born in British India during the Raj, Cassiopaeiae was brought up by her maternal aunt and this book is a tribute to her “two” mothers: her natural mother and her aunt, whom she always called Mamma.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?3504dd5f